import { useState } from "react";
import { toast } from "sonner";
import { Wand2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";

const EXAMPLES = ["Ricordami 48 ore prima della scadenza degli ordini urgenti e alti della commessa Monza", "Sollecita le criticità non prese in carico sul cimitero di Monza"];

export const InstructPanel = ({ onCreated }) => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/toth/instruct", { text });
      setRes(data);
      if (data.supported) onCreated?.();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="card-soft p-5" data-testid="toth-instruct">
      <h3 className="flex items-center gap-2 font-bold"><Wand2 className="h-4 w-4 text-primary" />Istruisci Toth</h3>
      <p className="mt-1 text-sm text-muted-foreground">Scrivi la regola a parole. Toth la traduce in una regola consentita e la salva come bozza: si attiva solo quando la approvi qui sotto.</p>
      <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={3} maxLength={2000} className="mt-3 rounded-xl" placeholder={EXAMPLES[0]} data-testid="toth-instruct-input" />
      <div className="mt-2 flex flex-wrap gap-2">
        {EXAMPLES.map((e, i) => <button key={e} onClick={() => setText(e)} className="rounded-full border px-3 py-1 text-xs font-semibold hover:bg-accent" data-testid={`toth-instruct-example-${i}`}>{e}</button>)}
      </div>
      <Button onClick={go} disabled={busy || text.trim().length < 10} className="mt-3 rounded-xl" data-testid="toth-instruct-submit">{busy && <Loader2 className="mr-1 h-4 w-4 animate-spin" />}Traduci in regola</Button>
      {res && (
        <div className={`mt-4 rounded-xl p-4 text-sm ${res.supported ? "bg-emerald-50" : "bg-amber-50"}`} data-testid="toth-instruct-result">
          {res.supported ? (
            <>
              <p className="font-bold">Bozza creata: {res.rule.name}</p>
              <p className="mt-1">{res.rule.explanation}</p>
              <p className="mt-1 text-xs text-muted-foreground">Tipo: {res.kind_label} · Ambito: {res.rule.scope}{res.rule.params.priorities && ` · Priorità: ${res.rule.params.priorities.join(", ")}`}{res.rule.params.hours_before && ` · ${res.rule.params.hours_before} ore prima`}</p>
              {res.rule.limits && <p className="mt-1 text-xs text-amber-800">Non realizzabile: {res.rule.limits}</p>}
            </>
          ) : <p><b>Istruzione non supportata.</b> {res.explanation}</p>}
        </div>
      )}
    </section>
  );
};
